ko.components.register('to-clipboard', {
	viewModel: function(params) {
		let self = this;

		self.hint = ko.observable(params && params.hint || 'Copy To Clipboard');
		self.label = ko.observable(params && params.label || '<span class="ic ic-copy"></span>');
		self.text = ko.observable(params && params.text || null);

		// methods

		self.copyToClipboard = function(text) {
			if(navigator.clipboard && window.isSecureContext)
				return navigator.clipboard.writeText(text);
			// textarea hack
			let textArea = document.createElement("textarea");
			textArea.value = text;
			textArea.style.position = "fixed";
			textArea.style.left = "-999999px";
			textArea.style.top = "-999999px";
			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();
			return new Promise((res, rej) => {
				document.execCommand('copy') ? res() : rej();
				textArea.remove();
			});
		}

		self.copy = function(d, ev) {
			ev.preventDefault();
			ev.stopPropagation();

			const data = self.text();
			self.copyToClipboard(data)
				.then(() => console.log('Copy ' + data))
				.catch(() => alert("Clipboard write failed"));

			return false;
		};
	},
	template: "<button class=\"to-clipboard tip\" data-bind=\"event: { click: copy }, html: label, attr: {title: hint}\"></button>"
});